import { Link, useParams } from 'react-router';

import { ROUTES } from '#/config/routes';
import { fetchWorkOrderDetail } from '#/api/momMgmt/workOrder/fetchDetail';
import { updateWorkOrderRemark } from '#/api/momMgmt/workOrder/updateRemark';
import { Button } from '#/modules/commonComponents/button';
import PageShell from '#/modules/infra/layout/PageShell';
import useDocumentRemarkSave from '#/hooks/useDocumentRemarkSave';
import DocumentRemarkEditForm from '#/modules/imsMgmt/receipts/shared/DocumentRemarkEditForm';
import WorkOrderMainInfoCard from '#/modules/momMgmt/workOrder/components/WorkOrderMainInfoCard';
import {
  getWorkOrderApiErrorMessage,
  isWorkOrderVersionConflict,
} from '#/modules/momMgmt/workOrder/helper/apiError';
import { canEditWorkOrderRemark } from '#/modules/momMgmt/workOrder/helper/workOrderStatus';
import {
  workOrderDetailQueryKey,
  workOrderListQueryKeyPrefix,
} from '#/utils/queryKeys';

const WorkOrderRemarkPage = () => {
  const { id } = useParams();

  const {
    detail,
    detailQuery,
    isPending,
    saveRemark,
  } = useDocumentRemarkSave({
    id,
    fetchDetail: fetchWorkOrderDetail,
    updateRemark: updateWorkOrderRemark,
    detailQueryKey: workOrderDetailQueryKey,
    listQueryKeyPrefix: workOrderListQueryKeyPrefix,
    getErrorMessage: (error) => getWorkOrderApiErrorMessage(error, '更新備註失敗'),
    isVersionConflict: isWorkOrderVersionConflict,
    afterSaveNavigateTo: ROUTES.workOrderDetail(id),
  });

  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;
  const remarkAllowed = detail ? canEditWorkOrderRemark(detail.status) : false;

  return (
    <PageShell variant="form">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div className="create_edit_page__header">
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">編輯工單備註</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.workOrderDetail(id)}>返回詳情</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getWorkOrderApiErrorMessage(detailQuery.error, '找不到工單')}
            </p>
          ) : null}

          {detail && !remarkAllowed ? (
            <div className="space-y-3">
              <p className="text-sm text-slate-600">此狀態不可編輯備註。</p>
              <Button type="button" asChild>
                <Link to={ROUTES.workOrderDetail(id)}>前往詳情</Link>
              </Button>
            </div>
          ) : null}

          {detail && remarkAllowed ? (
            <>
              <WorkOrderMainInfoCard detail={detail} />
              <DocumentRemarkEditForm
                initialRemark={detail.remark ?? ''}
                cancelTo={ROUTES.workOrderDetail(id)}
                isPending={isPending}
                onSave={saveRemark}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default WorkOrderRemarkPage;
